export default __webpack_public_path__ + "images/JY.8d51d93.png";